<template>
  <el-dialog
      v-dialogDrag
      :closeOnClickModal="false"
      :visible.sync="isVisible"
      class="abow_dialog"
      top="5vh"
      ref="myDialog"
      width="45vw"
      :fullscreen="isFullScreen"
      append-to-body
      :show-close="false"
      :before-close="dialogCancel">
    <div slot="title" class="header-title">
      <!--      <el-image class="dgImg" :src="require('../../assets/icons/dg-xz.png')"></el-image>-->
      <div class="dgTitle">{{ dialogTitle }}</div>
      <el-image class="dgImg2" :src="require('../../assets/icons/dg-gb.png')" @click="dialogCancel"></el-image>
    </div>
    <slot name="dialogFrom"></slot>
    <span slot="footer" class="dialog-footer">
       <el-button @click="dialogCancel" class="dgClose">{{closeText}}</el-button>
        <template v-if="!isRead">
          <el-popconfirm title="确认该操作吗？" style="padding-left: 10px" @confirm="dialogConfirm"
                         ref="popFirm">
            <el-button slot="reference" type="primary" @click="dialogVerify()" class="dgSave">{{saveText}}
            </el-button>
          </el-popconfirm>
        </template>
    </span>
  </el-dialog>
</template>

<script>
/**
 * @Author: ygh
 * @Date: 2024/3/21 15:04
 * @Description:数据弹出框
 */
export default {
  name: "dataDialog",
  props: {
    dialogTitle: {
      type: String,
      default: '',
    },
    closeText: {
      type: String,
      default: '关 闭',
    },
    saveText: {
      type: String,
      default: '保 存',
    },
    isShowHead: {
      type: Boolean,
      default: true,
    },
    isShowFooter: {
      type: Boolean,
      default: true,
    },
    isOwnStyle: {
      type: Boolean,
      default: false,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    isListenerSizeChange: {
      type: Boolean,
      default: false,
    },
    isRead: {
      type: Boolean,
      default: false,
    },
    dgStyle: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      isFullScreen: false,
    }
  },
  mounted() {
    this.$refs.myDialog.$el.addEventListener('maxMinCalled', () => {
      if (this.isListenerSizeChange) {
        this.dialogSizeChange();
      }
    });
    if (this.isOwnStyle) {
      this.$nextTick(() => {
        // this.$refs.myDialog.$el.style.marginTop;//外层dialog的样式设置
        let div = this.$refs.myDialog.$el.getElementsByClassName('el-dialog')[0];
        for (let key in this.dgStyle) {//样式替换处理
          if (div.style[key] !== undefined) {
            div.style[key] = this.dgStyle[key];
          }
        }
      })
    }
    if (!this.isShowHead) {
      let div = this.$refs.myDialog.$el.getElementsByClassName('el-dialog')[0];
      let head = div.getElementsByClassName('el-dialog__header')[0];
      head.style.display = 'none';
    }
    if (!this.isShowFooter) {
      let div = this.$refs.myDialog.$el.getElementsByClassName('el-dialog')[0];
      let foot = div.getElementsByClassName('el-dialog__footer')[0];
      foot.style.display = 'none';
    }
  },
  methods: {
    dialogSizeChange() {
      this.$emit('dgSizeChangeDeal', '');
    },
    dialogCancel() {
      this.$emit('dgCancelDeal', '');
    },
    dialogVerify() {
      this.$emit('dgVerifyDeal', '');
    },
    dialogConfirm() {
      this.$emit('dgConfirmDeal', '');
    },
    isShowPop(isShow) {
      this.$refs.popFirm.visible = !isShow;
    },
  },
}
</script>

<style scoped>
.dgClose {
  width: 8vh;
  height: 3vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #0066ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: solid 1px #53abfd;
  border-radius: 2px;
}

.dgSave {
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}

.dgImg {
  margin-left: 2vh;
  width: 2vh;
  height: 2vh;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
}

.dgImg2 {
  position: absolute;
  right: 2vh;
  top: 1.5vh;
  width: 3vh;
  height: 3vh;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.dgImg3 {
  position: absolute;
  right: 6vh;
  top: 1.5vh;
  width: 3vh;
  height: 3vh;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.dgTitle {
  margin-left: 2vh;
  font-family: PingFang SC;
  font-size: 1.6vh;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vh;
  color: #323232;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
}

.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}

::v-deep .el-dialog {
  margin: 0 auto;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  height: 6vh;
  line-height: 6vh;
  padding: 0;
  /*background: linear-gradient(to bottom, #00A4B2, #2785D8);*/
  background-color: #F0EFEF;
  position: relative;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

::v-deep .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 10px;
  height: 5vh;
  line-height: 5vh;
}

::v-deep .el-dialog__body {
  padding: 10px 20px 0px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  position: absolute;
  left: 0;
  top: 6vh;
  bottom: 70px;
  right: 0;
  overflow: auto;
}

::v-deep .dialog-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 70px;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  align-items: Center;
  box-sizing: border-box;
  padding-right: 20px;
}

::v-deep .el-dialog {
  height: 70%;
}

</style>
